/* eslint-disable @next/next/no-img-element */
import GradientContainer from "../gradient/gradient-container"

interface TechnologyItemProps {
  description: string,
}

const TechnologyItem = ({ description }: TechnologyItemProps) => (
  <div className="flex items-center space-x-4">
    <GradientContainer gradientDirection="bg-gradient-to-t" overrideClassName="h-[44px] w-[4px]" />
    <p className="text-text-color-mid-em text-body-xl-medium">{description}</p>
  </div>
)

const TechnologyItems = [
  {key: "01", description: "Centralize your operations"},
  {key: "02", description: "Track your services"},
  {key: "03", description: "Drive workforce production"},
  {key: "04", description: "Capture data analytics"},
  {key: "05", description: "Enhance your process"},
]

const Technology = () => {
  return (
    <div className="p-10 lg:p-20 xl:px-[120px] xl-2:px-[160px]">
      <div className="space-y-2 mb-10">
        <h5 className="text-secondary text-body-2xl md:subheading-xl lg:subheading-xxl-2">Technology</h5>
        <GradientContainer overrideClassName="w-full h-[4px] rounded" />
      </div>
      <div className="flex flex-col lg:flex-row lg:space-x-16">
        <div className="flex flex-col items-center space-y-6 lg:basis-1/2">
          <img
            className="rounded w-full"
            src="/images/platform/services.png"
            alt="technology"
          />
          <div className="px-4 sm:px-20 md:px-36 lg:px-0 xl-2:px-8 2xl:px-20 3xl:px-36">
            <p className="text-text-color-high-em h6 text-center xl:h5">
              Our tech stack was designed for the waste and recycling industry
            </p>
          </div>
        </div>
        <div className="mt-10 space-y-10 lg:mt-0 lg:basis-1/2">
          <h6 className="text-base-dark text-center h6 sm:h5 lg:text-start lg:h4 xl:h3 4xl:pr-20">
            Discover the benefits of advanced technology.
          </h6>
          <div className="space-y-4">
            {TechnologyItems.map((item) => (
              <TechnologyItem key={item.key} description={item.description} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Technology
